import React from 'react';
import { CardLineContainer, CompareCardBody } from './styles';
import { Box, Stack } from '@mui/material';
import Text from '../../shared/Text';
import Heading from '../../shared/Heading';
import { ComparativeCardLine } from '.';

export function CardLine() {
  return (
    <CardLineContainer>
      <Text as="p" size="small" weight="normal" color="gray">
        Comparativo
      </Text>
      <Heading as="h2" color="black" size="medium">
        Acessos
      </Heading>

      <ComparativeCardLine />

      <CompareCardBody>
        <Box>
          <Text as="p" size="large" weight="semibold" color="green">
            10%
          </Text>
          <Text as="p" size="medium" weight="semibold">
            vs Ano passado
          </Text>
          <Text as="p" size="small" weight="normal">
            Nov (2022)
          </Text>
        </Box>

        <Stack
          sx={{
            marginRight: '2rem',
            borderLeft: '1px solid rgba(143,144,166, 0.3)',
          }}
        >
          <Box sx={{ marginLeft: '0.7rem' }}>
            <Text as="p" size="large" weight="semibold" color="green">
              7%
            </Text>
            <Text as="p" size="medium" weight="semibold">
              vs Mês passado
            </Text>
            <Text as="p" size="small" weight="normal">
              Out (2023)
            </Text>
          </Box>
        </Stack>
      </CompareCardBody>
    </CardLineContainer>
  );
}
